// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-layout {
  margin-left: 200px; /* Adjust this based on your sidebar width */
}

/* Layout.css */

/* Mobile styles for Sidebar, Navbar, etc. */
@media only screen and (max-width: 768px) {
  .sider {
    display: none; /* Hide sidebar on mobile */
  }

  .navbar {
    padding: 10px;
    font-size: 16px;
  }

  .content {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB,EAAE,4CAA4C;AAClE;;AAEA,eAAe;;AAEf,4CAA4C;AAC5C;EACE;IACE,aAAa,EAAE,2BAA2B;EAC5C;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".site-layout {\n  margin-left: 200px; /* Adjust this based on your sidebar width */\n}\n\n/* Layout.css */\n\n/* Mobile styles for Sidebar, Navbar, etc. */\n@media only screen and (max-width: 768px) {\n  .sider {\n    display: none; /* Hide sidebar on mobile */\n  }\n\n  .navbar {\n    padding: 10px;\n    font-size: 16px;\n  }\n\n  .content {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
